


<template>
  <div class="stack_active_set_A">
    

    <div class="box chart">
      <div class="header"> <h2>🎯 이번달 실적</h2>  <button>상담 시작</button> </div>
      <div class="content">
        <div id="circleContainer"></div>
        <h2>{{ progress_text }}</h2>
      </div>

      <div class="description">
        <span>상담 <h4>10</h4> 건 <gap></gap><gap></gap> 계약 <h4>8</h4>건 </span>
        <span>월P <b>1,055,000</b> 원</span>
      </div>
    </div>
    

    <div class="box todo">
      <div class="header"> <h2>📆 일정 <small>5월 2주차</small> </h2>  <button>관리</button> </div>
      <div class="chapter"> <h2>총 8건</h2> <span>상담 3건</span> <span>미팅 2건</span> </div>
      <ul>
        <li v-for="(item, index) in todo_list" :key="index"><i :class="'ph '+item.class"></i> <span>{{item.time}}</span> <span>{{ item.type }}</span> <img :src="item.thumb"> <span>{{item.name}}님 ({{item.age}}세/{{item.sex}})</span> </li>
      </ul>
    </div>


    <div class="box unfinished">
      <div class="header"> <h2>📚 미완료 업무 (4)</h2> </div>
      <ul>
        <li v-for="(item, index) in unfinished_list" :key="index"><p>{{ item.what }} {{ item.status }}</p> <p>{{ item.name }}</p> <button>계속하기</button></li>
      </ul>
    </div>


  </div>
</template>




<script>
import ProgressBar from 'progressbar.js'

export default {
  mounted() {

    const bar = new ProgressBar.Circle('#circleContainer', {
      color: '#FFA500',
      strokeWidth: 12,
      trailColor: '#e6e6e640',
      trailWidth: 12,
      duration: 1400,
      easing: 'easeInOut',
    });
    bar.path.setAttribute('stroke-linecap', 'round'); // ✅ This is the key
    bar.animate(this.progress_per); // 75%

  },
  data() {
    return {
      progress_per: 0.75,
      progress_text: '75%',
      unfinished_list: [
        {what:"보장분석", status:"진행중", name:"홍길동"},
        {what:"상담기록", status:"미작성", name:"김미정"},
        {what:"설계", status:"작성중", name:"이영희"},
        {what:"설계", status:"작성중", name:"최윤호"},
      ],
      todo_list: [
        {time:"11:00", type:"상담", name:"김수만", age:33, sex:"남", class:"ph-check-square", thumb:"https://cdn.pixabay.com/photo/2025/05/08/21/10/pattern-9588100_1280.jpg"},
        {time:"14:00", type:"미팅", name:"홍두께", age:45, sex:"여", class:"ph-check-square", thumb:"https://cdn.pixabay.com/photo/2025/05/04/17/47/dog-9578735_1280.jpg"},
        {time:"16:00", type:"일반", name:"박변식", age:11, sex:"남", class:"ph-square", thumb:"https://cdn.pixabay.com/photo/2025/04/22/05/54/dog-9548923_640.jpg"},
        {time:"19:00", type:"상담", name:"장원정", age:22, sex:"여", class:"ph-square", thumb:"https://cdn.pixabay.com/photo/2025/03/19/07/25/sparrow-9480012_640.jpg"},
      ],
    }
  },
  methods: {
    clicked() {
    }
  }
}
</script>




<style scoped>

@media (max-width: 1024px) or (max-height: 800px) {
  .stack_active_set_A {
    grid-template-columns: repeat(1, 1fr) !important;
    grid-template-rows : repeat(3, 1fr) !important;
    height:fit-content !important;
    padding:16px;
    box-sizing: border-box;
  }
}

ul {
  list-style: none;
  padding:0;
  margin:0;
}

h2 {
  font-size: 16px;
  font-weight: 600;
  padding:0;
  margin:0;
}

p {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.stack_active_set_A {
  width: 100%;
  height: 38vh;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap:24px;
}

.box {
  width:100%;
  height:100%;
  background: var(--color-surface);
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap:12px;
  backdrop-filter: blur(24px);
  overflow:hidden;
}

.header {
  width:100%;
  height:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header > h2 {
  font-size: 20px;
  font-weight: 600;
  padding:0;
  margin:0;
}

.header > span {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
}

.header > button {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
  background: var(--color-brand);
  color: var(--color-text-primary);
  border-radius: 8px;
  border:none;
  padding:8px 16px;
}

.header small {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  margin-left: 6px;
}

.stacks {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:24px;
}

.stacks > .stack {
  width: 100%;
  height: 100%;
  flex:1;
  background: var(--color-surface);
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: start;
  gap:12px;
  flex-direction: column;
  backdrop-filter: blur(24px);
}

.chart {
  gap:16px;
  display:flex;
  flex-direction: column;
}

.chart > .content {
  width:100%;
  height:100%;
  flex:3;
  display:flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.chart > .content > #circleContainer {
  width: auto;
  height: 100%;
  aspect-ratio: 1/1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart > .content > h2 {
  position: absolute;
  font-size: 36px;
  font-weight: 800;
  padding:0;
  margin:0;
}

.chart > .description {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap:12px;
  font-size: 16px;
}

.chart > .description > span {
  font-size: 16px;
  font-weight: 400;
  padding:0;
  margin:0;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:8px;
}

.chart > .description > span > b {
  font-size: 20px;
  font-weight: 800;
  padding:0;
  margin:0;
}

.chart > .description > span > h4 {
  font-size: 20px;
  font-weight: 800;
  padding:0;
  margin:0;
  color: var(--color-brand);
}

.todo {
  gap:16px;
  display:flex;
  flex-direction: column;
}

.todo > .chapter {
  width:100%;
  height:30px;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:24px;
  font-size:16px;
  font-weight: 400;
  border-bottom:2px solid var(--color-surface-reverse);
}

.todo > .chapter > h2 {
  color:var(--color-brand)
}

.todo > ul {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:6px;
}

.todo > ul > li {
  width:100%;
  height:36px;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:12px;
  font-size:16px;
  font-weight:400;
}

.todo > ul > li > i {
  font-size:24px;
  color:var(--color-brand);
}

.todo > ul > li > span {
  font-size:16px;
  font-weight:400;
  color:var(--color-text-primary);
}

.todo > ul > li > img {
  width:24px;
  height:24px;
  border-radius:50%;
  background-color: var(--color-text-secondary);
  object-fit: cover;
}

.unfinished {
  gap:16px;
  display:flex;
  flex-direction: column;
}

.unfinished > ul {
  width:100%;
  height:100%;
  flex:1;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:12px;
}

.unfinished > ul > li {
  width:100%;
  height:fit-content;
  display:flex;
  justify-content: start;
  align-items: center;
  gap:12px;
  font-size:16px;
  font-weight:400;
  background: var(--color-surface);
  border-radius: 12px;
  padding:6px;
  box-sizing: border-box;
}

.unfinished > ul > li > p {
  font-size:14px;
  font-weight:400;
  flex:1;
  color:var(--color-text-primary);
}

.unfinished > ul > li > button {
  width:fit-content;
  height: 36px;
  font-size:14px;
  font-weight:400;
  background: var(--color-text-secondary);
  color: var(--color-text-primary);
  border-radius: 8px;
  border:none;
  padding:4px 16px;
  cursor: pointer;
}

</style>
